import React, {Component} from 'react';

class KouponiAppSample extends Component{
  render(){
    return (
      <div className="r_kouponi-container">
        <div id="app-external" className="r-kouponi theme-legacy" style={{marginBottom: '0px'}}>
          <div className="">
  <div className="r-kouponi-filters">
    <div className="filter show-filter">
      <span className="label">Φίλτρο προβολής</span>
      <div className="btn-group">
        <button onClick={(e) => e.preventDefault()} className="filter-button active" data-filter="SHOW_ALL">Όλα</button>
        <button onClick={(e) => e.preventDefault()} className="" data-filter="SHOW_ONLY_SELECTED">
          <i className="label-icon fa fa-star"></i>Τα παιχνίδια μου
        </button>
        <button onClick={(e) => e.preventDefault()} className="filter-button" data-filter="SHOW_ONLY_LIVE">Σε εξέλιξη</button>
        <button onClick={(e) => e.preventDefault()} className="filter-button" data-filter="SHOW_ONLY_FINISHED">Τελικά αποτελέσματα</button>
      </div>
    </div>
    <div className="filter sound-filter"><button onClick={(e) => e.preventDefault()} className="btn-icon btn-toggle"><span className="fa fa-stack"><i className="fa fa-volume-off fa-stack-1x"></i><i className="fa fa-ban fa-stack-2x"></i></span></button></div>
  </div>
  <div>
    <table>
      <thead>
        <tr>
           <th style={{textAlign: 'center'}} rowSpan="2" className="general-cell comp" colSpan="2">Δ</th>
           <th style={{textAlign: 'center'}} rowSpan="2" className="time-cell time">Ω/Ε</th>
           <th style={{textAlign: 'center'}} rowSpan="2" className="opap-code-cell code">ΚΩΔ.</th>
           <th style={{textAlign: 'center'}} rowSpan="2" className="general-cell sm ee">Ε/Ε</th>
           <th style={{textAlign: 'center'}} rowSpan="2" className="odd-cell em lg">1</th>
           <th style={{textAlign: 'center'}} rowSpan="2" className="team-cell team">ΓΗΠΕΔΟΥΧΟΣ</th>
           <th style={{textAlign: 'center'}} rowSpan="2" className="odd-cell em lg">Χ</th>
           <th style={{textAlign: 'center'}} rowSpan="2" className="team-cell team">ΦΙΛΟΞΕΝΟΥΜΕΝΗ</th>
           <th style={{textAlign: 'center'}} rowSpan="2" className="odd-cell em lg divider">2</th>
           <th style={{textAlign: 'center'}} colSpan="2" className="team-cell divider">UNDER / OVER <br/> 2.5 GOALS</th>
           <th style={{textAlign: 'center'}} rowSpan="2" className="score-cell score">HM</th>
           <th style={{textAlign: 'center'}} rowSpan="2" className="score-cell score">ΣΚΟΡ</th>
           <th style={{textAlign: 'center'}} rowSpan="2" className="general-cell result"><i className="fa fa-clock-o"></i></th>
           <th style={{textAlign: 'center'}} rowSpan="2" className="general-cell lg result"><i className="fa fa-line-chart"></i></th>
           <th style={{textAlign: 'center'}} rowSpan="2" className="general-cell"><i className="fa fa-star"></i></th>
        </tr>
        <tr>
          <th className="odd-cell em">U</th>
          <th className="odd-cell em divider">O</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td colSpan="18" className="date_header">
            <div className="date-controls">
              <div className="disable-select date-controls_arrow date-controls_arrow--left" data-date="2018-03-13">Τρίτη 13 Μαρ 2018</div>
              <div className="disable-select date-controls_arrow date-controls_arrow--right" data-date="2018-03-15">Πέμπτη 15 Μαρ 2018</div>
              <div className="disable-select date-controls_header">Wednesday 14 Mar 2018<span>Επιλογή ημερομηνίας</span></div>
              <div className="date-controls_dropdown">
                <ul>
                  <li data-date="2018-03-09">Παρασκευή 09 Μαρ 2018</li>
                  <li data-date="2018-03-10">Σάββατο 10 Μαρ 2018</li>
                  <li data-date="2018-03-11">Κυριακή 11 Μαρ 2018</li>
                  <li data-date="2018-03-12">Δευτέρα 12 Μαρ 2018</li>
                  <li data-date="2018-03-13">Τρίτη 13 Μαρ 2018</li>
                  <li data-date="2018-03-14" className="active">Τετάρτη 14 Μαρ 2018</li>
                  <li data-date="2018-03-15">Πέμπτη 15 Μαρ 2018</li>
                  <li data-date="2018-03-16">Παρασκευή 16 Μαρ 2018</li>
                  <li data-date="2018-03-17">Σάββατο 17 Μαρ 2018</li>
                </ul>
              </div>
            </div>
          </td>
        </tr>
        <tr data-id="1237603" className="">
          <td className="general-cell em comp"><img src="https://wbsearthcomps-5c24.kxcdn.com/svg/4x3/JAP.svg" alt="ΙΑΠΩΝΙΑ : ΛΙΓΚ ΚΑΠ : ΟΜΙΛΟΣ Δ"/></td>
          <td className="general-cell em comp_name">ΙΑΛΚ</td>
          <td className="time-cell bold time">13:00</td>
          <td className="opap-code-cell bold code">2002</td>
          <td className="sm mins mins2">2</td>
          <td className="odd-cell lg odd oddF"><span>2.35</span></td>
          <td className=" team-cell team teamA">
            ΤΟΣΟΥ
            <div className="rd_container"></div>
          </td>
          <td className="odd-cell lg odd oddF"><span>2.90</span></td>
          <td className="bold team-cell team teamB">
            <div className="rd_container"></div>
            ΒΙΣΣΕΛ ΚΟΜΠΕ
          </td>
          <td className="odd-cell lg odd oddF divider"><span>2.65</span></td>
          <td className="odd-cell odd-cell  odd"><span>1.60</span></td>
          <td className="odd-cell odd divider"><span>1.90</span></td>
          <td className="score-cell score ht">0-1</td>
          <td className="score-cell score ft has_events">
            0-2
            <div className="events_container">
              <table>
                <tbody>
                  <tr className="header">
                    <td colSpan="2" className="team1">ΤΟΣΟΥ</td>
                    <td>
                      <div>
                        <div className="score">0 - 2</div>
                        <div className="halfscore">( 0 - 1 )</div>
                      </div>
                    </td>
                    <td colSpan="2" className="team2">ΒΙΣΣΕΛ ΚΟΜΠΕ</td>
                  </tr>
                  <tr>
                    <td width="10%"></td>
                    <td width="32.5%" className="player1"></td>
                    <td width="15%" className="min">4'</td>
                    <td width="32.5%" className="player2">Kazuma Watanabe</td>
                    <td width="10%"><i className="fa fa-futbol-o"></i></td>
                  </tr>
                  <tr>
                    <td width="10%"></td>
                    <td width="32.5%" className="player1"></td>
                    <td width="15%" className="min">90'</td>
                    <td width="32.5%" className="player2">Shuhei Otsuki</td>
                    <td width="10%"><i className="fa fa-futbol-o"></i></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </td>
          <td className="general-cell cond">2</td>
          <td className="general-cell more_odds"><button  onClick={(e) => e.preventDefault()}>+10<i className="fa fa-angle-down"></i></button></td>
          <td className="general-cell  add_fav" data-id="1237603"><i className="fa fa-star"></i></td>
        </tr>
        <tr data-id="1237547" className="">
          <td className="general-cell em comp"><img src="https://wbsearthcomps-5c24.kxcdn.com/svg/4x3/WCUP.svg" alt="ΚΥΠΕΛΛΟ ΑΣΙΑΣ : ΟΜΙΛΟΣ Δ"/></td>
          <td className="general-cell em comp_name">ΑΣΠ</td>
          <td className="time-cell bold time">13:30</td>
          <td className="opap-code-cell bold code">678</td>
          <td className="sm mins mins2">2</td>
          <td className="odd-cell lg odd oddF"><span>2.00</span></td>
          <td className=" team-cell team teamA">
            ΑΛΤΙΝ ΑΣΙΡ
            <div className="rd_container"></div>
          </td>
          <td className="odd-cell lg odd oddF"><span>2.95</span></td>
          <td className=" team-cell team teamB">
            <div className="rd_container"></div>
            ΦΚ ΙΣΤΙΚΛΟΛ
          </td>
          <td className="odd-cell lg odd oddF divider"><span>3.25</span></td>
          <td className="odd-cell odd-cell  odd"><span>1.52</span></td>
          <td className="odd-cell odd divider"><span>2.02</span></td>
          <td className="score-cell score ht">-</td>
          <td className="score-cell score ft">2-2</td>
          <td className="general-cell cond">X</td>
          <td className="general-cell more_odds"><button  onClick={(e) => e.preventDefault()}>+10<i className="fa fa-angle-down"></i></button></td>
          <td className="general-cell  add_fav" data-id="1237547"><i className="fa fa-star"></i></td>
        </tr>
        <tr data-id="1239477" className="">
          <td className="general-cell em comp"><img src="https://wbsearthcomps-5c24.kxcdn.com/svg/4x3/SER.svg" alt="ΣΕΡΒΙΑ : ΚΥΠΕΛΛΟ : ΠΡΟΗΜΙΤΕΛΙΚΟΙ"/></td>
          <td className="general-cell em comp_name">ΣΕΡΚ</td>
          <td className="time-cell bold time">14:00</td>
          <td className="opap-code-cell bold code">683</td>
          <td className="sm mins mins3">3</td>
          <td className="odd-cell lg odd oddF"><span>10.00</span></td>
          <td className=" team-cell team teamA">
            ΓΙΑΒΟΡ ΜΑΤΙΖ
            <div className="rd_container"></div>
          </td>
          <td className="odd-cell lg odd oddF"><span>4.50</span></td>
          <td className="bold team-cell team teamB">
            <div className="rd_container"></div>
            ΠΑΡΤΙΖΑΝ
          </td>
          <td className="odd-cell lg odd oddF divider"><span>1.20</span></td>
          <td className="odd-cell odd-cell  odd"><span>1.78</span></td>
          <td className="odd-cell odd divider"><span>1.72</span></td>
          <td className="score-cell score ht">0-0</td>
          <td className="score-cell score ft has_events">
            0-2
            <div className="events_container">
              <table>
                <tbody>
                  <tr className="header">
                    <td colSpan="2" className="team1">ΓΙΑΒΟΡ ΜΑΤΙΖ</td>
                    <td>
                      <div>
                        <div className="score">0 - 2</div>
                        <div className="halfscore">( 0 - 0 )</div>
                      </div>
                    </td>
                    <td colSpan="2" className="team2">ΠΑΡΤΙΖΑΝ</td>
                  </tr>
                  <tr>
                    <td width="10%"></td>
                    <td width="32.5%" className="player1"></td>
                    <td width="15%" className="min">65'</td>
                    <td width="32.5%" className="player2">Ognjen Ozegovic</td>
                    <td width="10%"><i className="fa fa-futbol-o"></i></td>
                  </tr>
                  <tr>
                    <td width="10%"></td>
                    <td width="32.5%" className="player1"></td>
                    <td width="15%" className="min">67'</td>
                    <td width="32.5%" className="player2">Nemanja Miletic</td>
                    <td width="10%"><i className="fa fa-futbol-o"></i></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </td>
          <td className="general-cell cond">2</td>
          <td className="general-cell more_odds"><button  onClick={(e) => e.preventDefault()}>+6<i className="fa fa-angle-down"></i></button></td>
          <td className="general-cell  add_fav" data-id="1239477"><i className="fa fa-star"></i></td>
        </tr>
        <tr data-id="1239426" className="">
          <td className="general-cell em comp"><img src="https://wbsearthcomps-5c24.kxcdn.com/svg/4x3/MON.svg" alt="ΜΑΥΡΟΒΟΥΝΙΟ : 1η ΚΑΤΗΓΟΡΙΑ"/></td>
          <td className="general-cell em comp_name">ΜΑΥΡ</td>
          <td className="time-cell bold time">15:00</td>
          <td className="opap-code-cell bold code">672</td>
          <td className="sm mins mins3">3</td>
          <td className="odd-cell lg odd oddF"><span>1.53</span></td>
          <td className=" team-cell team teamA">
            ΜΛΑΝΤΟΣΤ ΠΟΝΤΓΚΟΡΙΚΑ
            <div className="rd_container"></div>
          </td>
          <td className="odd-cell lg odd oddF"><span>3.15</span></td>
          <td className=" team-cell team teamB">
            <div className="rd_container"></div>
            ΙΣΚΡΑ ΝΤΑΝΙΛΟΒΟΓΚΡΑΝΤ
          </td>
          <td className="odd-cell lg odd oddF divider"><span>5.70</span></td>
          <td className="odd-cell odd-cell  odd"><span>1.40</span></td>
          <td className="odd-cell odd divider"><span>2.30</span></td>
          <td className="score-cell score ht">0-0</td>
          <td className="score-cell score ft live HT">0-0</td>
          <td className="general-cell cond minute">64</td>
          <td className="general-cell more_odds"><button  onClick={(e) => e.preventDefault()}>+10<i className="fa fa-angle-down"></i></button></td>
          <td className="general-cell  add_fav" data-id="1239426"><i className="fa fa-star"></i></td>
        </tr>
        <tr data-id="1198372" className="">
          <td className="general-cell em comp"><img src="https://wbsearthcomps-5c24.kxcdn.com/svg/4x3/AZE.svg" alt="ΑΖΕΡΜΠΑΙΤΖΑΝ : ΠΡΕΜΙΕΡ ΛΙΓΚ"/></td>
          <td className="general-cell em comp_name">ΑΖΕ</td>
          <td className="time-cell bold time">15:00</td>
          <td className="opap-code-cell bold code">2001</td>
          <td className="sm mins mins3">3</td>
          <td className="odd-cell lg odd oddF"><span>1.42</span></td>
          <td className=" team-cell team teamA">
            ΖΙΡΑ
            <div className="rd_container"></div>
          </td>
          <td className="odd-cell lg odd oddF"><span>3.50</span></td>
          <td className=" team-cell team teamB">
            <div className="rd_container"></div>
            ΣΑΜΠΑΓΙΛ
          </td>
          <td className="odd-cell lg odd oddF divider"><span>5.90</span></td>
          <td className="odd-cell odd-cell  odd"><span>1.58</span></td>
          <td className="odd-cell odd divider"><span>1.92</span></td>
          <td className="score-cell score ht">1-0</td>
          <td className="score-cell score ft live HT has_events">
            1-1
            <div className="events_container">
              <table>
                <tbody>
                  <tr className="header">
                    <td colSpan="2" className="team1">ΖΙΡΑ</td>
                    <td>
                      <div>
                        <div className="score">1 - 1</div>
                        <div className="min">59</div>
                      </div>
                    </td>
                    <td colSpan="2" className="team2">ΣΑΜΠΑΓΙΛ</td>
                  </tr>
                  <tr>
                    <td width="10%"></td>
                    <td width="32.5%" className="player1"></td>
                    <td width="15%" className="min">54'</td>
                    <td width="32.5%" className="player2">Nika Apakidze</td>
                    <td width="10%"><i className="fa fa-futbol-o"></i></td>
                  </tr>
                  <tr>
                    <td width="10%"><i className="fa fa-futbol-o"></i></td>
                    <td width="32.5%" className="player1">Richard Gadze</td>
                    <td width="15%" className="min">17'</td>
                    <td width="32.5%" className="player2"></td>
                    <td width="10%"></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </td>
          <td className="general-cell cond minute">59</td>
          <td className="general-cell more_odds"><button  onClick={(e) => e.preventDefault()}>+6<i className="fa fa-angle-down"></i></button></td>
          <td className="general-cell  add_fav" data-id="1198372"><i className="fa fa-star"></i></td>
        </tr>
        <tr data-id="1239372" className="">
          <td className="general-cell em comp"><img src="https://wbsearthcomps-5c24.kxcdn.com/svg/4x3/EGY.svg" alt="ΑΙΓΥΠΤΟΣ - 1η ΚΑΤΗΓΟΡΙΑ"/></td>
          <td className="general-cell em comp_name">ΑΙΓ</td>
          <td className="time-cell bold time">15:00</td>
          <td className="opap-code-cell bold code">2005</td>
          <td className="sm mins mins3">3</td>
          <td className="odd-cell lg odd oddF"><span>1.75</span></td>
          <td className=" team-cell team teamA">
            ΤΑΝΤΑ
            <div className="rd_container"></div>
          </td>
          <td className="odd-cell lg odd oddF"><span>2.80</span></td>
          <td className="bold team-cell team teamB">
            <div className="rd_container"></div>
            ΑΣΙΟΥΤΙ ΣΠΟΡΤ
          </td>
          <td className="odd-cell lg odd oddF divider"><span>4.40</span></td>
          <td className="odd-cell odd-cell  odd"><span>1.35</span></td>
          <td className="odd-cell odd divider"><span>2.45</span></td>
          <td className="score-cell score ht">0-1</td>
          <td className="score-cell score ft live HT has_events">
            0-1
            <div className="events_container">
              <table>
                <tbody>
                  <tr className="header">
                    <td colSpan="2" className="team1">ΤΑΝΤΑ</td>
                    <td>
                      <div>
                        <div className="score">0 - 1</div>
                        <div className="min">52</div>
                      </div>
                    </td>
                    <td colSpan="2" className="team2">ΑΣΙΟΥΤΙ ΣΠΟΡΤ</td>
                  </tr>
                  <tr>
                    <td width="10%"></td>
                    <td width="32.5%" className="player1"></td>
                    <td width="15%" className="min">45'</td>
                    <td width="32.5%" className="player2">Benson Shilongo</td>
                    <td width="10%"><i className="fa fa-futbol-o"></i></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </td>
          <td className="general-cell cond minute">52</td>
          <td className="general-cell more_odds"><button  onClick={(e) => e.preventDefault()}>+10<i className="fa fa-angle-down"></i></button></td>
          <td className="general-cell  add_fav" data-id="1239372"><i className="fa fa-star"></i></td>
        </tr>
        <tr data-id="1161384" className="">
          <td className="general-cell em comp"><img src="https://wbsearthcomps-5c24.kxcdn.com/svg/4x3/SLO.svg" alt="ΣΛΟΒΕΝΙΑ - 1η ΚΑΤΗΓΟΡΙΑ"/></td>
          <td className="general-cell em comp_name">ΣΛΟΒ</td>
          <td className="time-cell bold time">15:00</td>
          <td className="opap-code-cell bold code">2006</td>
          <td className="sm mins mins3">3</td>
          <td className="odd-cell lg odd oddF"><span>1.47</span></td>
          <td className=" team-cell team teamA">
            ΤΣΕΛΙΕ
            <div className="rd_container"></div>
          </td>
          <td className="odd-cell lg odd oddF"><span>3.50</span></td>
          <td className=" team-cell team teamB">
            <div className="rd_container"></div>
            ΖΙΒΙΛΑ ΤΡΙΓΚΛΑΒ
          </td>
          <td className="odd-cell lg odd oddF divider"><span>5.40</span></td>
          <td className="odd-cell odd-cell  odd"><span>1.65</span></td>
          <td className="odd-cell odd divider"><span>1.85</span></td>
          <td className="score-cell score ht">2-2</td>
          <td className="score-cell score ft live HT has_events">
            2-2
            <div className="events_container">
              <table>
                <tbody>
                  <tr className="header">
                    <td colSpan="2" className="team1">ΤΣΕΛΙΕ</td>
                    <td>
                      <div>
                        <div className="score">2 - 2</div>
                        <div className="min">61</div>
                      </div>
                    </td>
                    <td colSpan="2" className="team2">ΖΙΒΙΛΑ ΤΡΙΓΚΛΑΒ</td>
                  </tr>
                  <tr>
                    <td width="10%"><i className="fa fa-futbol-o"></i></td>
                    <td width="32.5%" className="player1">Tilen Pecnik</td>
                    <td width="15%" className="min">45'</td>
                    <td width="32.5%" className="player2"></td>
                    <td width="10%"></td>
                  </tr>
                  <tr>
                    <td width="10%"></td>
                    <td width="32.5%" className="player1"></td>
                    <td width="15%" className="min">32'</td>
                    <td width="32.5%" className="player2">Matej Poplatnik</td>
                    <td width="10%"><i className="fa fa-futbol-o"></i></td>
                  </tr>
                  <tr>
                    <td width="10%"></td>
                    <td width="32.5%" className="player1"></td>
                    <td width="15%" className="min">18'</td>
                    <td width="32.5%" className="player2">Matej Poplatnik</td>
                    <td width="10%"><i className="fa fa-futbol-o"></i></td>
                  </tr>
                  <tr>
                    <td width="10%"><i className="fa fa-futbol-o"></i></td>
                    <td width="32.5%" className="player1">Nino Pungarsek</td>
                    <td width="15%" className="min">17'</td>
                    <td width="32.5%" className="player2"></td>
                    <td width="10%"></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </td>
          <td className="general-cell cond minute">61</td>
          <td className="general-cell more_odds"><button  onClick={(e) => e.preventDefault()}>+6<i className="fa fa-angle-down"></i></button></td>
          <td className="general-cell  add_fav" data-id="1161384"><i className="fa fa-star"></i></td>
        </tr>
        <tr data-id="1239397" className="">
          <td className="general-cell em comp"><img src="https://wbsearthcomps-5c24.kxcdn.com/svg/4x3/EUR.svg" alt="ΟΥΕΦΑ : ΛΙΓΚΑ ΝΕΩΝ : ΠΡΟΗΜΙΤΕΛΙΚΟΣ"/></td>
          <td className="general-cell em comp_name">U19</td>
          <td className="time-cell bold time">15:00</td>
          <td className="opap-code-cell bold code">2007</td>
          <td className="sm mins mins2">2</td>
          <td className="odd-cell lg odd oddF"><span>2.20</span></td>
          <td className=" team-cell team teamA">
            ΜΑΝΤΣΕΣΤΕΡ ΣΙΤΙ U19
            <div className="rd_container"></div>
          </td>
          <td className="odd-cell lg odd oddF"><span>3.45</span></td>
          <td className=" team-cell team teamB">
            <div className="rd_container"></div>
            ΛΙΒΕΡΠΟΥΛ U19
          </td>
          <td className="odd-cell lg odd oddF divider"><span>2.45</span></td>
          <td className="odd-cell odd-cell  odd"><span>2.30</span></td>
          <td className="odd-cell odd divider"><span>1.40</span></td>
          <td className="score-cell score ht"></td>
          <td className="score-cell score ft"></td>
          <td className="general-cell cond"><i className="fa fa-clock-o"></i></td>
          <td className="general-cell more_odds"><button  onClick={(e) => e.preventDefault()}>+10<i className="fa fa-angle-down"></i></button></td>
          <td className="general-cell  add_fav" data-id="1239397"><i className="fa fa-star"></i></td>
        </tr>
        <tr data-id="1208201" className=" nofeed">
          <td className="general-cell em comp"><img src="https://wbsearthcomps-5c24.kxcdn.com/svg/4x3/ITA.svg" alt="ΙΤΑΛΙΑ : ΣΕΡΙΕ Δ : ΓΚΡΟΥΠ 5"/></td>
          <td className="general-cell em comp_name">ITC4</td>
          <td className="time-cell bold time">15:30</td>
          <td className="opap-code-cell bold code">609</td>
          <td className="sm mins mins3">3</td>
          <td className="odd-cell lg odd oddF"><span>2.25</span></td>
          <td className=" team-cell team teamA">
            ΑΡΤΖΕΝΤΙΝΑ S.R.L.
            <div className="rd_container"></div>
          </td>
          <td className="odd-cell lg odd oddF"><span>3.10</span></td>
          <td className=" team-cell team teamB">
            <div className="rd_container"></div>
            ΣΑΝ ΝΤΟΝΑΤΟ ΤΑΒΑΡΝΕΛΕ
          </td>
          <td className="odd-cell lg odd oddF divider"><span>2.60</span></td>
          <td className="odd-cell odd-cell  odd"><span>1.70</span></td>
          <td className="odd-cell odd divider"><span>1.80</span></td>
          <td className="score-cell score ht"></td>
          <td className="score-cell score ft"><i className="fa fa-bell-slash tool" data-tooltip="ΜΟΝΟ ΤΕΛΙΚΟ ΑΠΟΤΕΛΕΣΜΑ"></i></td>
          <td className="general-cell cond"><i className="fa fa-clock-o"></i></td>
          <td className="general-cell more_odds"><button  onClick={(e) => e.preventDefault()}>+6<i className="fa fa-angle-down"></i></button></td>
          <td className="general-cell  add_fav" data-id="1208201"><i className="fa fa-star"></i></td>
        </tr>
        <tr data-id="1239392" className="">
          <td className="general-cell em comp"><img src="https://wbsearthcomps-5c24.kxcdn.com/svg/4x3/SLV.svg" alt="ΣΛΟΒΑΚΙΑ : ΚΥΠΕΛΛΟ : ΠΡΟΗΜΙΤΕΛΙΚΟΙ"/></td>
          <td className="general-cell em comp_name">ΣΛΟΚ</td>
          <td className="time-cell bold time">15:30</td>
          <td className="opap-code-cell bold code">2010</td>
          <td className="sm mins mins3">3</td>
          <td className="odd-cell lg odd oddF"><span>10.00</span></td>
          <td className=" team-cell team teamA">
            ΙΣΚΡΑ ΜΠΟΡΖΙΤΣΕ
            <div className="rd_container"></div>
          </td>
          <td className="odd-cell lg odd oddF"><span>5.70</span></td>
          <td className="bold team-cell team teamB">
            <div className="rd_container"></div>
            ΖΙΛΙΝΑ
          </td>
          <td className="odd-cell lg odd oddF divider"><span>1.14</span></td>
          <td className="odd-cell odd-cell  odd"><span>2.45</span></td>
          <td className="odd-cell odd divider"><span>1.35</span></td>
          <td className="score-cell score ht">-</td>
          <td className="score-cell score ft live HT has_events">
            0-1
            <div className="events_container">
              <table>
                <tbody>
                  <tr className="header">
                    <td colSpan="2" className="team1">ΙΣΚΡΑ ΜΠΟΡΖΙΤΣΕ</td>
                    <td>
                      <div>
                        <div className="score">0 - 1</div>
                        <div className="min">44</div>
                      </div>
                    </td>
                    <td colSpan="2" className="team2">ΖΙΛΙΝΑ</td>
                  </tr>
                  <tr>
                    <td width="10%"></td>
                    <td width="32.5%" className="player1"></td>
                    <td width="15%" className="min">26'</td>
                    <td width="32.5%" className="player2">Juraj Chvatal</td>
                    <td width="10%"><i className="fa fa-futbol-o"></i></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </td>
          <td className="general-cell cond minute">44</td>
          <td className="general-cell more_odds"><button  onClick={(e) => e.preventDefault()}>+6<i className="fa fa-angle-down"></i></button></td>
          <td className="general-cell  add_fav" data-id="1239392"><i className="fa fa-star"></i></td>
        </tr>
        <tr data-id="1207887" className=" nofeed">
          <td className="general-cell em comp"><img src="https://wbsearthcomps-5c24.kxcdn.com/svg/4x3/ITA.svg" alt="ΙΤΑΛΙΑ : ΣΕΡΙΕ Δ : ΓΚΡΟΥΠ 4"/></td>
          <td className="general-cell em comp_name">ITC4</td>
          <td className="time-cell bold time">15:30</td>
          <td className="opap-code-cell bold code">2454</td>
          <td className="sm mins mins3">3</td>
          <td className="odd-cell lg odd oddF"><span>2.20</span></td>
          <td className=" team-cell team teamA">
            ΒΙΓΚΟΡ ΚΑΡΠΑΝΕΤΟ
            <div className="rd_container"></div>
          </td>
          <td className="odd-cell lg odd oddF"><span>3.10</span></td>
          <td className=" team-cell team teamB">
            <div className="rd_container"></div>
            ΠΙΑΝΕΣΕ
          </td>
          <td className="odd-cell lg odd oddF divider"><span>2.70</span></td>
          <td className="odd-cell odd-cell  odd"><span>1.70</span></td>
          <td className="odd-cell odd divider"><span>1.80</span></td>
          <td className="score-cell score ht"></td>
          <td className="score-cell score ft"><i className="fa fa-bell-slash tool" data-tooltip="ΜΟΝΟ ΤΕΛΙΚΟ ΑΠΟΤΕΛΕΣΜΑ"></i></td>
          <td className="general-cell cond"><i className="fa fa-clock-o"></i></td>
          <td className="general-cell more_odds"><button  onClick={(e) => e.preventDefault()}>+6<i className="fa fa-angle-down"></i></button></td>
          <td className="general-cell  add_fav" data-id="1207887"><i className="fa fa-star"></i></td>
        </tr>
        <tr data-id="1195733" className=" nofeed">
          <td className="general-cell em comp"><img src="https://wbsearthcomps-5c24.kxcdn.com/svg/4x3/CRO.svg" alt="ΚΡΟΑΤΙΑ : 2η ΚαΤΗΓΟΡΙΑ"/></td>
          <td className="general-cell em comp_name">ΚΡΟ2</td>
          <td className="time-cell bold time">16:00</td>
          <td className="opap-code-cell bold code">664</td>
          <td className="sm mins mins3">3</td>
          <td className="odd-cell lg odd oddF"><span>1.78</span></td>
          <td className=" team-cell team teamA">
            ΒΑΡΑΖΝΤΙΝ
            <div className="rd_container"></div>
          </td>
          <td className="odd-cell lg odd oddF"><span>3.00</span></td>
          <td className=" team-cell team teamB">
            <div className="rd_container"></div>
            ΝΤΟΥΓΚΟΠΟΛΖΕ
          </td>
          <td className="odd-cell lg odd oddF divider"><span>3.90</span></td>
          <td className="odd-cell odd-cell  odd"><span>1.48</span></td>
          <td className="odd-cell odd divider"><span>2.10</span></td>
          <td className="score-cell score ht"></td>
          <td className="score-cell score ft"><i className="fa fa-bell-slash tool" data-tooltip="ΜΟΝΟ ΤΕΛΙΚΟ ΑΠΟΤΕΛΕΣΜΑ"></i></td>
          <td className="general-cell cond"><i className="fa fa-clock-o"></i></td>
          <td className="general-cell more_odds"><button  onClick={(e) => e.preventDefault()}>+6<i className="fa fa-angle-down"></i></button></td>
          <td className="general-cell  add_fav" data-id="1195733"><i className="fa fa-star"></i></td>
        </tr>
        <tr data-id="1239429" className="">
          <td className="general-cell em comp"><img src="https://wbsearthcomps-5c24.kxcdn.com/svg/4x3/MON.svg" alt="ΜΑΥΡΟΒΟΥΝΙΟ : 1η ΚΑΤΗΓΟΡΙΑ"/></td>
          <td className="general-cell em comp_name">ΜΑΥΡ</td>
          <td className="time-cell bold time">16:00</td>
          <td className="opap-code-cell bold code">673</td>
          <td className="sm mins mins3">3</td>
          <td className="odd-cell lg odd oddF"><span>8.00</span></td>
          <td className=" team-cell team teamA">
            ΝΤΕΣΙΤΣ ΤΟΥΖΙ
            <div className="rd_container"></div>
          </td>
          <td className="odd-cell lg odd oddF"><span>3.35</span></td>
          <td className=" team-cell team teamB">
            <div className="rd_container"></div>
            ΜΠΟΥΝΤΟΥΣΝΟΣΤ
          </td>
          <td className="odd-cell lg odd oddF divider"><span>1.38</span></td>
          <td className="odd-cell odd-cell  odd"><span>1.37</span></td>
          <td className="odd-cell odd divider"><span>2.40</span></td>
          <td className="score-cell score ht">-</td>
          <td className="score-cell score ft live HT">0-0</td>
          <td className="general-cell cond minute">19</td>
          <td className="general-cell more_odds"><button  onClick={(e) => e.preventDefault()}>+10<i className="fa fa-angle-down"></i></button></td>
          <td className="general-cell  add_fav" data-id="1239429"><i className="fa fa-star"></i></td>
        </tr>
        <tr data-id="1198371" className="">
          <td className="general-cell em comp"><img src="https://wbsearthcomps-5c24.kxcdn.com/svg/4x3/AZE.svg" alt="ΑΖΕΡΜΠΑΙΤΖΑΝ : ΠΡΕΜΙΕΡ ΛΙΓΚ"/></td>
          <td className="general-cell em comp_name">ΑΖΕ</td>
          <td className="time-cell bold time">16:00</td>
          <td className="opap-code-cell bold code">2000</td>
          <td className="sm mins mins3">3</td>
          <td className="odd-cell lg odd oddF"><span>5.50</span></td>
          <td className=" team-cell team teamA">
            ΝΕΦΤΣΙ ΜΠΑΚΟΥ
            <div className="rd_container"></div>
          </td>
          <td className="odd-cell lg odd oddF"><span>3.40</span></td>
          <td className=" team-cell team teamB">
            <div className="rd_container"></div>
            ΚΑΡΑΜΠΑΚ
          </td>
          <td className="odd-cell lg odd oddF divider"><span>1.48</span></td>
          <td className="odd-cell odd-cell  odd"><span>1.50</span></td>
          <td className="odd-cell odd divider"><span>2.05</span></td>
          <td className="score-cell score ht">-</td>
          <td className="score-cell score ft live HT">0-0</td>
          <td className="general-cell cond minute">20</td>
          <td className="general-cell more_odds"><button  onClick={(e) => e.preventDefault()}>+6<i className="fa fa-angle-down"></i></button></td>
          <td className="general-cell  add_fav" data-id="1198371"><i className="fa fa-star"></i></td>
        </tr>
        <tr data-id="1160551" className="">
          <td className="general-cell em comp"><img src="https://wbsearthcomps-5c24.kxcdn.com/svg/4x3/CRO.svg" alt="ΚΡΟΑΤΙΑ : 1η ΚΑΤΗΓΟΡΙΑ"/></td>
          <td className="general-cell em comp_name">ΚΡΟ</td>
          <td className="time-cell bold time">16:00</td>
          <td className="opap-code-cell bold code">2012</td>
          <td className="sm mins mins3">3</td>
          <td className="odd-cell lg odd oddF"><span>2.10</span></td>
          <td className=" team-cell team teamA">
            ΤΣΙΜΠΑΛΙΑ
            <div className="rd_container"></div>
          </td>
          <td className="odd-cell lg odd oddF"><span>2.90</span></td>
          <td className=" team-cell team teamB">
            <div className="rd_container"></div>
            ΡΟΥΝΤΕΣ
          </td>
          <td className="odd-cell lg odd oddF divider"><span>3.05</span></td>
          <td className="odd-cell odd-cell  odd"><span>1.52</span></td>
          <td className="odd-cell odd divider"><span>2.02</span></td>
          <td className="score-cell score ht">-</td>
          <td className="score-cell score ft live HT">0-0</td>
          <td className="general-cell cond minute">19</td>
          <td className="general-cell more_odds"><button  onClick={(e) => e.preventDefault()}>+6<i className="fa fa-angle-down"></i></button></td>
          <td className="general-cell  add_fav" data-id="1160551"><i className="fa fa-star"></i></td>
        </tr>
        <tr data-id="1239416" className="">
          <td className="general-cell em comp"><img src="https://wbsearthcomps-5c24.kxcdn.com/svg/4x3/WCUP.svg" alt="ΚΥΠΕΛΛΟ ΑΣΙΑΣ : ΟΜΙΛΟΣ Ε"/></td>
          <td className="general-cell em comp_name">ΑΣΠ</td>
          <td className="time-cell bold time">16:30</td>
          <td className="opap-code-cell bold code">682</td>
          <td className="sm mins mins2">2</td>
          <td className="odd-cell lg odd oddF"><span>1.38</span></td>
          <td className=" team-cell team teamA">
            ΜΠΕΝΓΚΑΛΟΥΡΟΥ
            <div className="rd_container"></div>
          </td>
          <td className="odd-cell lg odd oddF"><span>3.85</span></td>
          <td className=" team-cell team teamB">
            <div className="rd_container"></div>
            ΝΤΑΚΑ ΑΜΠΑΧΑΝΙ
          </td>
          <td className="odd-cell lg odd oddF divider"><span>5.90</span></td>
          <td className="odd-cell odd-cell  odd"><span>1.78</span></td>
          <td className="odd-cell odd divider"><span>1.72</span></td>
          <td className="score-cell score ht"></td>
          <td className="score-cell score ft"></td>
          <td className="general-cell cond"><i className="fa fa-clock-o"></i></td>
          <td className="general-cell more_odds"><button  onClick={(e) => e.preventDefault()}>+10<i className="fa fa-angle-down"></i></button></td>
          <td className="general-cell  add_fav" data-id="1239416"><i className="fa fa-star"></i></td>
        </tr>
        <tr data-id="1239478" className="">
          <td className="general-cell em comp"><img src="https://wbsearthcomps-5c24.kxcdn.com/svg/4x3/SER.svg" alt="ΣΕΡΒΙΑ : ΚΥΠΕΛΛΟ : ΠΡΟΗΜΙΤΕΛΙΚΟΙ"/></td>
          <td className="general-cell em comp_name">ΣΕΡΚ</td>
          <td className="time-cell bold time">16:30</td>
          <td className="opap-code-cell bold code">684</td>
          <td className="sm mins mins3">3</td>
          <td className="odd-cell lg odd oddF"><span>10.00</span></td>
          <td className=" team-cell team teamA">
            ΜΑΤΣΒΑ ΣΑΜΠΑΤΣ
            <div className="rd_container"></div>
          </td>
          <td className="odd-cell lg odd oddF"><span>5.10</span></td>
          <td className=" team-cell team teamB">
            <div className="rd_container"></div>
            ΕΡΥΘΡΟΣ ΑΣΤΕΡΑΣ
          </td>
          <td className="odd-cell lg odd oddF divider"><span>1.17</span></td>
          <td className="odd-cell odd-cell  odd"><span>2.05</span></td>
          <td className="odd-cell odd divider"><span>1.50</span></td>
          <td className="score-cell score ht"></td>
          <td className="score-cell score ft"></td>
          <td className="general-cell cond"><i className="fa fa-clock-o"></i></td>
          <td className="general-cell more_odds"><button  onClick={(e) => e.preventDefault()}>+6<i className="fa fa-angle-down"></i></button></td>
          <td className="general-cell  add_fav" data-id="1239478"><i className="fa fa-star"></i></td>
        </tr>
        <tr data-id="1160554" className="">
          <td className="general-cell em comp"><img src="https://wbsearthcomps-5c24.kxcdn.com/svg/4x3/CRO.svg" alt="ΚΡΟΑΤΙΑ : 1η ΚΑΤΗΓΟΡΙΑ"/></td>
          <td className="general-cell em comp_name">ΚΡΟ</td>
          <td className="time-cell bold time">16:30</td>
          <td className="opap-code-cell bold code">2013</td>
          <td className="sm mins mins3">3</td>
          <td className="odd-cell lg odd oddF"><span>1.25</span></td>
          <td className=" team-cell team teamA">
            ΟΣΙΓΙΕΚ
            <div className="rd_container"></div>
          </td>
          <td className="odd-cell lg odd oddF"><span>4.30</span></td>
          <td className=" team-cell team teamB">
            <div className="rd_container"></div>
            ΙΝΤΕΡ ΖΑΠΡΕΖΙΤΣ
          </td>
          <td className="odd-cell lg odd oddF divider"><span>7.75</span></td>
          <td className="odd-cell odd-cell  odd"><span>1.90</span></td>
          <td className="odd-cell odd divider"><span>1.60</span></td>
          <td className="score-cell score ht"></td>
          <td className="score-cell score ft"></td>
          <td className="general-cell cond"><i className="fa fa-clock-o"></i></td>
          <td className="general-cell more_odds"><button  onClick={(e) => e.preventDefault()}>+6<i className="fa fa-angle-down"></i></button></td>
          <td className="general-cell  add_fav" data-id="1160554"><i className="fa fa-star"></i></td>
        </tr>
        <tr data-id="1239728" className="">
          <td className="general-cell em comp"><img src="https://wbsearthcomps-5c24.kxcdn.com/svg/4x3/HUN.svg" alt="ΟΥΓΓΑΡΙΑ : ΚΥΠΕΛΛΟ : ΠΡΟΗΜΙΤΕΛΙΚΟΙ"/></td>
          <td className="general-cell em comp_name">ΟΥΓΚ</td>
          <td className="time-cell bold time">17:00</td>
          <td className="opap-code-cell bold code">619</td>
          <td className="sm mins mins3">3</td>
          <td className="odd-cell lg odd oddF"><span>1.77</span></td>
          <td className=" team-cell team teamA">
            ΧΟΝΒΕΝΤ
            <div className="rd_container"></div>
          </td>
          <td className="odd-cell lg odd oddF"><span>3.30</span></td>
          <td className=" team-cell team teamB">
            <div className="rd_container"></div>
            ΝΤΕΜΠΡΕΤΣΕΝ
          </td>
          <td className="odd-cell lg odd oddF divider"><span>3.50</span></td>
          <td className="odd-cell odd-cell  odd"><span>1.85</span></td>
          <td className="odd-cell odd divider"><span>1.65</span></td>
          <td className="score-cell score ht"></td>
          <td className="score-cell score ft"></td>
          <td className="general-cell cond"><i className="fa fa-clock-o"></i></td>
          <td className="general-cell more_odds"><button  onClick={(e) => e.preventDefault()}>+6<i className="fa fa-angle-down"></i></button></td>
          <td className="general-cell  add_fav" data-id="1239728"><i className="fa fa-star"></i></td>
        </tr>
        <tr data-id="1238488" className="">
          <td className="general-cell em comp"><img src="https://wbsearthcomps-5c24.kxcdn.com/svg/4x3/CYP.svg" alt="ΚΥΠΡΟΣ : ΚΥΠΕΛΛΟ : ΠΡΟΗΜΙΤΕΛΙΚΟΙ"/></td>
          <td className="general-cell em comp_name">ΚΥΚ</td>
          <td className="time-cell bold time">17:00</td>
          <td className="opap-code-cell bold code">2014</td>
          <td className="sm mins mins3">3</td>
          <td className="odd-cell lg odd oddF"><span>2.25</span></td>
          <td className=" team-cell team teamA">
            ΑΝΟΡΘΩΣΙΣ
            <div className="rd_container"></div>
          </td>
          <td className="odd-cell lg odd oddF"><span>3.00</span></td>
          <td className=" team-cell team teamB">
            <div className="rd_container"></div>
            ΑΠΟΛΛΩΝ ΛΕΜΕΣΟΥ
          </td>
          <td className="odd-cell lg odd oddF divider"><span>2.65</span></td>
          <td className="odd-cell odd-cell  odd"><span>1.60</span></td>
          <td className="odd-cell odd divider"><span>1.90</span></td>
          <td className="score-cell score ht"></td>
          <td className="score-cell score ft"></td>
          <td className="general-cell cond"><i className="fa fa-clock-o"></i></td>
          <td className="general-cell more_odds"><button  onClick={(e) => e.preventDefault()}>+6<i className="fa fa-angle-down"></i></button></td>
          <td className="general-cell  add_fav" data-id="1238488"><i className="fa fa-star"></i></td>
        </tr>
        <tr data-id="1181461" className="">
          <td className="general-cell em comp"><img src="https://wbsearthcomps-5c24.kxcdn.com/svg/4x3/POR.svg" alt="ΠΟΡΤΟΓΑΛΙΑ - 2η ΚΑΤΗΓΟΡΙΑ"/></td>
          <td className="general-cell em comp_name">ΠΟΡ2</td>
          <td className="time-cell bold time">17:00</td>
          <td className="opap-code-cell bold code">2016</td>
          <td className="sm mins mins3">3</td>
          <td className="odd-cell lg odd oddF"><span>1.60</span></td>
          <td className=" team-cell team teamA">
            ΑΚΑΔΕΜΙΚΑ
            <div className="rd_container"></div>
          </td>
          <td className="odd-cell lg odd oddF"><span>3.20</span></td>
          <td className=" team-cell team teamB">
            <div className="rd_container"></div>
            ΛΕΪΣΟΕΣ
          </td>
          <td className="odd-cell lg odd oddF divider"><span>4.70</span></td>
          <td className="odd-cell odd-cell  odd"><span>1.60</span></td>
          <td className="odd-cell odd divider"><span>1.90</span></td>
          <td className="score-cell score ht"></td>
          <td className="score-cell score ft"></td>
          <td className="general-cell cond"><i className="fa fa-clock-o"></i></td>
          <td className="general-cell more_odds"><button  onClick={(e) => e.preventDefault()}>+10<i className="fa fa-angle-down"></i></button></td>
          <td className="general-cell  add_fav" data-id="1181461"><i className="fa fa-star"></i></td>
        </tr>
        <tr data-id="1179579" className="">
          <td className="general-cell em comp"><img src="https://wbsearthcomps-5c24.kxcdn.com/svg/4x3/FRA.svg" alt="ΓΑΛΛΙΑ : 1η ΚΑΤΗΓΟΡΙΑ"/></td>
          <td className="general-cell em comp_name">ΓΑΛ</td>
          <td className="time-cell bold time">18:00</td>
          <td className="opap-code-cell bold code">2029</td>
          <td className="sm mins mins1">1</td>
          <td className="odd-cell lg odd oddF"><span>1.03</span></td>
          <td className=" team-cell team teamA">
            ΠΑΡΙ ΣΕΝ ΖΕΡΜΕΝ
            <div className="rd_container"></div>
          </td>
          <td className="odd-cell lg odd oddF"><span>10.00</span></td>
          <td className=" team-cell team teamB">
            <div className="rd_container"></div>
            ΑΝΖΕ
          </td>
          <td className="odd-cell lg odd oddF divider"><span>22.00</span></td>
          <td className="odd-cell odd-cell  odd"><span>4.25</span></td>
          <td className="odd-cell odd divider"><span>1.10</span></td>
          <td className="score-cell score ht"></td>
          <td className="score-cell score ft"></td>
          <td className="general-cell cond"><i className="fa fa-clock-o"></i></td>
          <td className="general-cell more_odds"><button  onClick={(e) => e.preventDefault()}>+10<i className="fa fa-angle-down"></i></button></td>
          <td className="general-cell  add_fav" data-id="1179579"><i className="fa fa-star"></i></td>
        </tr>
        <tr data-id="1198019" className="">
          <td className="general-cell em comp"><img src="https://wbsearthcomps-5c24.kxcdn.com/svg/4x3/ITA.svg" alt="ΙΤΑΛΙΑ : ΣΕΡΙΕ A"/></td>
          <td className="general-cell em comp_name">ΙΤΑ</td>
          <td className="time-cell bold time">19:00</td>
          <td className="opap-code-cell bold code">2034</td>
          <td className="sm mins mins1">1</td>
          <td className="odd-cell lg odd oddF"><span>1.30</span></td>
          <td className=" team-cell team teamA">
            ΓΙΟΥΒΕΝΤΟΥΣ
            <div className="rd_container"></div>
          </td>
          <td className="odd-cell lg odd oddF"><span>4.30</span></td>
          <td className=" team-cell team teamB">
            <div className="rd_container"></div>
            ΑΤΑΛΑΝΤΑ
          </td>
          <td className="odd-cell lg odd oddF divider"><span>8.50</span></td>
          <td className="odd-cell odd-cell  odd"><span>1.70</span></td>
          <td className="odd-cell odd divider"><span>1.80</span></td>
          <td className="score-cell score ht"></td>
          <td className="score-cell score ft"></td>
          <td className="general-cell cond"><i className="fa fa-clock-o"></i></td>
          <td className="general-cell more_odds"><button  onClick={(e) => e.preventDefault()}>+10<i className="fa fa-angle-down"></i></button></td>
          <td className="general-cell  add_fav" data-id="1198019"><i className="fa fa-star"></i></td>
        </tr>
        <tr data-id="1239393" className="">
          <td className="general-cell em comp"><img src="https://wbsearthcomps-5c24.kxcdn.com/svg/4x3/SLV.svg" alt="ΣΛΟΒΑΚΙΑ : ΚΥΠΕΛΛΟ : ΠΡΟΗΜΙΤΕΛΙΚΟΙ"/></td>
          <td className="general-cell em comp_name">ΣΛΟΚ</td>
          <td className="time-cell bold time">19:00</td>
          <td className="opap-code-cell bold code">2035</td>
          <td className="sm mins mins3">3</td>
          <td className="odd-cell lg odd oddF"><span>1.11</span></td>
          <td className=" team-cell team teamA">
            ΣΛΟΒΑΝ ΜΠΡΑΤΙΣΛΑΒΑΣ
            <div className="rd_container"></div>
          </td>
          <td className="odd-cell lg odd oddF"><span>5.90</span></td>
          <td className=" team-cell team teamB">
            <div className="rd_container"></div>
            ΤΑΤΡΑΝ ΛΙΠΤΟΒΣΚΙ ΜΙΚ.
          </td>
          <td className="odd-cell lg odd oddF divider"><span>13.00</span></td>
          <td className="odd-cell odd-cell  odd"><span>2.40</span></td>
          <td className="odd-cell odd divider"><span>1.37</span></td>
          <td className="score-cell score ht"></td>
          <td className="score-cell score ft"></td>
          <td className="general-cell cond"><i className="fa fa-clock-o"></i></td>
          <td className="general-cell more_odds"><button  onClick={(e) => e.preventDefault()}>+6<i className="fa fa-angle-down"></i></button></td>
          <td className="general-cell  add_fav" data-id="1239393"><i className="fa fa-star"></i></td>
        </tr>
        <tr data-id="1239449" className=" nofeed">
          <td className="general-cell em comp"><img src="https://wbsearthcomps-5c24.kxcdn.com/svg/4x3/COL.svg" alt="ΚΟΛΟΜΒΙΑ : ΚΥΠΕΛΛΟ : 1ΟΣ ΓΥΡΟΣ"/></td>
          <td className="general-cell em comp_name">ΚΟΛΚ</td>
          <td className="time-cell bold time">22:30</td>
          <td className="opap-code-cell bold code">661</td>
          <td className="sm mins mins2">2</td>
          <td className="odd-cell lg odd oddF"><span>1.87</span></td>
          <td className=" team-cell team teamA">
            ΛΑΝΕΡΟΣ
            <div className="rd_container"></div>
          </td>
          <td className="odd-cell lg odd oddF"><span>3.05</span></td>
          <td className=" team-cell team teamB">
            <div className="rd_container"></div>
            ΜΑΓΔΑΛΕΝΑ ΣΑΝΤΑ ΜΑΡΙΑ
          </td>
          <td className="odd-cell lg odd oddF divider"><span>3.50</span></td>
          <td className="odd-cell odd-cell  odd"><span>1.58</span></td>
          <td className="odd-cell odd divider"><span>1.92</span></td>
          <td className="score-cell score ht"></td>
          <td className="score-cell score ft"><i className="fa fa-bell-slash tool" data-tooltip="ΜΟΝΟ ΤΕΛΙΚΟ ΑΠΟΤΕΛΕΣΜΑ"></i></td>
          <td className="general-cell cond"><i className="fa fa-clock-o"></i></td>
          <td className="general-cell more_odds"><button  onClick={(e) => e.preventDefault()}>+10<i className="fa fa-angle-down"></i></button></td>
          <td className="general-cell  add_fav" data-id="1239449"><i className="fa fa-star"></i></td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
      </div>
    </div>
    )
  }
}


export default KouponiAppSample;


// WEBPACK FOOTER //
// ./src/components/samples/kouponiAppSample.js